'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeaturedStats = exports.CAROUSEL_SELECTOR = exports.CONTAINER_SELECTOR = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _CarouselSection2 = require('./../../sections/carousel/CarouselSection');

var _ShopifySection = require('./../../sections/ShopifySection');

var _Responsive = require('./../../settings/Responsive');

var ResponsiveSizes = _interopRequireWildcard(_Responsive);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONTAINER_SELECTOR = exports.CONTAINER_SELECTOR = '[data-featured-stats]'; /*
                                                                                *  Featured Stats
                                                                                *    Scripts for the Featured Stats section.
                                                                                *    Customiser blocks in a basic Slick carousel.
                                                                                *
                                                                                *  Version:
                                                                                *    1.0.0 - 2020/05/18
                                                                                */

var CAROUSEL_SELECTOR = exports.CAROUSEL_SELECTOR = '[data-featured-stats-carousel]';

var FeaturedStats = exports.FeaturedStats = function (_CarouselSection) {
  (0, _inherits3.default)(FeaturedStats, _CarouselSection);

  function FeaturedStats(container) {
    (0, _classCallCheck3.default)(this, FeaturedStats);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FeaturedStats.__proto__ || Object.getPrototypeOf(FeaturedStats)).call(this, container));

    _this.carouselContainer = container.find(CAROUSEL_SELECTOR);
    _this.initSlickCarousel();
    $(window).on('resize orientationchange', function () {
      return _this.onResize();
    });
    return _this;
  }

  (0, _createClass3.default)(FeaturedStats, [{
    key: 'onResize',
    value: function onResize() {
      if (this.carouselContainer.hasClass(_CarouselSection2.CLASS_INITIALIZED)) return;
      if ($(window).width() > ResponsiveSizes.medium) return;
      this.initSlickCarousel();
    }
  }, {
    key: 'initSlickCarousel',
    value: function initSlickCarousel() {
      if (this.carouselContainer.length) {
        this.slick = this.initCarousel(this.carouselContainer);
      }
    }
  }, {
    key: 'optionOverrides',
    value: function optionOverrides() {
      var _ref;

      return _ref = {
        infinite: this.container.data('infinite') === true ? true : false,
        autoplay: this.container.data('autoplay') == true,
        autoplaySpeed: this.container.data('autoplay-speed') * 1000 || 5000,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false
      }, (0, _defineProperty3.default)(_ref, 'arrows', false), (0, _defineProperty3.default)(_ref, 'adaptiveHeight', true), (0, _defineProperty3.default)(_ref, 'responsive', [{
        breakpoint: 500,
        settings: {
          slidesToShow: 2
        }
      }, {
        breakpoint: ResponsiveSizes.medium - 1,
        settings: "unslick"
      }]), _ref;
    }
  }]);
  return FeaturedStats;
}(_CarouselSection2.CarouselSection);

(0, _ShopifySection.register)(CONTAINER_SELECTOR, FeaturedStats);